module.exports = __webpack_public_path__ + "static/media/home.b8b24264.jpeg";